/**
 * 气候降雨
 */
class DZModelClimate{
    
    /**
     * 土地信息ID
     */
    landId = "";

    /**
     *气候类型ID
     */
    climateType = "";

    /**
     *日照时长h/年
     */
    sunlightDuration = "";

    /**
     *日照率
     */
    sunshineRate = "";

    /**
     *年平均气温
     */
    averageTemperature = "";

    /**
     *无霜期
     */
    frostfreePeriod = "";

    /**
     *降雨量
     */
    rainfall = "";

    /**
     *湿度
     */
    humidity = "";
}
export default DZModelClimate